import {
    Attributes as InternalAttributes,
    DateInstances as InternalDateInstances,
} from '@mews-framework/good-data/generated/internal';
import {
    Attributes as MewsBIAttributes,
    DateInstances as MewsBIDateInstances,
} from '@mews-framework/good-data/generated/mewsbi';
import { DatePeriod } from '../../common/components/ReportingDateRangePicker';

export enum MeasureFilterType {
    PositiveAttribute = 'PositiveAttribute',
    NegativeAttribute = 'NegativeAttribute',
    AbsoluteDate = 'AbsoluteDate',
    RelativeDate = 'RelativeDate',
}

export interface AbsoluteDateMeasureFilter {
    endDate: string;
    id: InternalDateInstances | MewsBIDateInstances;
    startDate: string;
    type: MeasureFilterType.AbsoluteDate;
}

export interface RelativeDateMeasureFilter {
    datePeriod: Exclude<DatePeriod, 'Custom'>;
    id: InternalDateInstances | MewsBIDateInstances;
    type: MeasureFilterType.RelativeDate;
}

export interface AttributeMeasureFilter {
    id: InternalAttributes | MewsBIAttributes;
    type: MeasureFilterType.PositiveAttribute | MeasureFilterType.NegativeAttribute;
    value: string[];
}

export type MeasureFilter = AbsoluteDateMeasureFilter | RelativeDateMeasureFilter | AttributeMeasureFilter;
